export default __webpack_public_path__ + "static/media/logo_with_border_design.79e35c09.png";